export const SITE_EXPERIENCES = {
    myfirstagent: {
        id: "myfirstagent",
        brand: { name: "My First Agent", shortName: "MFA" },
        themeId: "mfa-playful",
        defaultLocale: "en",
        supportedLocales: ["en", "es"],
        terminology: { owner: "Owner" },
    },
    launchyouragent: {
        id: "launchyouragent",
        brand: { name: "Launch Your Agent", shortName: "LYA" },
        themeId: "lya-corporate",
        defaultLocale: "en",
        supportedLocales: ["en", "es"],
        terminology: { owner: "Owner" },
    },
};
// Server-side SEO copy stamped into the served index.html for the resolved host
// (crawlers and link previews never see the client-side title swap). canonicalBase
// carries no trailing slash.
export const SITE_SEO = {
    myfirstagent: {
        title: "My First Agent — your first AI agent is one sentence away",
        description: "Say what your agent should do and watch it snap together out of real blocks. Build, run, and direct real AI agents — free to start, no credit card.",
        canonicalBase: "https://myfirstagent.ai",
    },
    launchyouragent: {
        title: "Launch Your Agent — build AI agents for your business",
        description: "Design, run, and iterate on real AI agents — connected to your tools, checked against your definition of done.",
        canonicalBase: "https://launchyouragent.ai",
    },
};
// The browser's host table. The server resolves tenants from its own MFA_HOSTS/LYA_HOSTS
// allowlists; the browser resolves from this list before its first request. Adding a
// front-end host means adding it here AND to the server's allowlist.
const BUILT_IN_HOSTS = {
    "myfirstagent.ai": "myfirstagent",
    "www.myfirstagent.ai": "myfirstagent",
    "mfa.localhost": "myfirstagent",
    localhost: "myfirstagent",
    "127.0.0.1": "myfirstagent",
    "launchyouragent.ai": "launchyouragent",
    "www.launchyouragent.ai": "launchyouragent",
    "lya.localhost": "launchyouragent",
};
export function resolveSiteId(rawHost) {
    const host = rawHost.trim().toLowerCase().replace(/\.$/, "").replace(/:\d+$/, "");
    return BUILT_IN_HOSTS[host] ?? null;
}
export function siteExperience(siteId) {
    return SITE_EXPERIENCES[siteId];
}
export function resolveSiteExperience(rawHost) {
    const id = resolveSiteId(rawHost);
    return id ? siteExperience(id) : null;
}
//# sourceMappingURL=site-config.js.map